import { useMediaQuery, useTheme } from "@material-ui/core";
import React from "react";
import { AutocompleteInput, ReferenceInput, SelectInput } from "react-admin";
import SubmitFilters from "../components/filters/SubmitFilters";
import { usersConfig } from "../users";
import statuses from "./statuses";

const Filters = (props) => {
	const theme = useTheme();
	const sm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
	return (
		<SubmitFilters {...props}>
			<ReferenceInput
				source="user_id"
				reference="users"
				alwaysOn={!sm}
				fullWidth
				style={{ marginTop: theme.spacing(4) }}
				{...usersConfig.reference}
			>
				<AutocompleteInput optionText="name" />
			</ReferenceInput>
			<SelectInput
				source="status"
				choices={statuses}
				optionText="name"
				alwaysOn
				resettable
				fullWidth
				allowEmpty
				emptyText="ra.action.all"
			/>
		</SubmitFilters>
	);
};
export default Filters;
